import { ContainerConfig, ControlConfig, LayoutConfig, EDIT, CUSTOM_LAYOUT } from './model';
import ConfigView from './ConfigView';
import CustomLayoutMask from './CustomLayoutMask';
import LayoutMan from './LayoutMan';
import GridContextMenu from './GridContextMenu';

export default {
    name: "Grid",
    props: {
        colInfo: {
            type: Array,
            default: () => ([])
        },
        layoutCfg: {
            type: Object,
            default: () => ({})
        },
        isCustomLayoutMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            LayoutCfg: JSON.parse(JSON.stringify(this.layoutCfg)),
            LayoutMan: new LayoutMan(),
            LayoutConfig: null,
            GridStyle: {},
            ContextMenuIsShow: false
        };
    },
    created() {
        this.CurRow = -1;
    },
    watch: {
        colInfo: {
            handler() {
                this.LayoutConfig = this.GetLayoutConfig();
            },
            immediate: true
        },
        layoutCfg: {
            handler() {
                this.LayoutCfg = JSON.parse(JSON.stringify(this.layoutCfg));
            }
        },
        LayoutCfg: {
            handler() {
                this.LayoutMan.SetLayoutConfig(this.LayoutConfig = this.GetLayoutConfig());
            },
            immediate: true
        },
        isCustomLayoutMode: {
            async handler() {
                if (this.isCustomLayoutMode) {

                    this.LayoutMan.SetSelectedList();
                    await this.$nextTick();
                    const _rowsHeight = this.LayoutConfig.GetRowsInfo().RowsHeight.join(" ");
                    
                    Object.assign(this.$refs.GridLayout.style, {
                        gridTemplateRows: _rowsHeight
                    });
                }
                else {
                    var _map = new Map();
                    this.LayoutConfig.Each((config) => { 
                        if (config instanceof ControlConfig) {
                            _map.set(config.ColInfo.ColName, config.Visible);
                        }
                    });
                    const _layoutConfig = this.LayoutConfig.Export();
                    const _layoutStr = JSON.stringify(_layoutConfig);
                    
                    if (JSON.stringify(this.layoutCfg?.VueEditLayout) !== _layoutStr) {

                        this.$confirm({
                            title: "提示",
                            content: "是否保存布局",
                            onOk: async () => {
                                this.$emit("layout-change", _layoutConfig);
                            },
                            onCancel: () => {
                                // this.LayoutCfg = JSON.parse(JSON.stringify(this.layoutCfg));
                                // this.$nextTick(() => {
                                //     this.LayoutConfig.Each(config => {
                                //         if (config instanceof ControlConfig) {
                                //             config.Visible = _map.has(config.ColInfo.ColName) ? _map.get(config.ColInfo.ColName) : true;
                                //         }
                                //     })
                                // });
                            }
                        });

                    }

                }
            }
        }
    },
    methods: {

        GetLayoutConfig() {
            
            // 过滤已经删除的配置
            
            const _vueEditLayout = JSON.parse(JSON.stringify(this.LayoutCfg?.VueEditLayout || { Children: [] }));

            const _colMap = new Map();

            this.colInfo.forEach(colInfo => {
                _colMap.set(colInfo.ColName, colInfo);
            });

            let _containerList = [_vueEditLayout];
            
            for (let _i = 0; _i < _containerList.length; _i++) {

                const _containerChildren = _containerList[_i].Children.filter(child => Array.isArray(child.Children));

                _containerList[_i].Children = _containerList[_i].Children.filter(child => _colMap.has(child.Name))

                _containerList = _containerList.concat(_containerChildren);

            }

            // 创建布局配置实例
            const _layoutConfig = new LayoutConfig({
                ...(_vueEditLayout),
                ColInfoList: this.colInfo.slice()
            });
            

            (_vueEditLayout.Children || []).forEach(child => {
                _layoutConfig.Append(child);
            });

            // 将新字段添加到布局中
            const _existsColNameList = new Set();
            
            _layoutConfig.Each(config => {

                if (config instanceof ControlConfig) {
                    _existsColNameList.add(config.Name);
                }

            });

            this.colInfo.filter(colInfo => !_existsColNameList.has(colInfo.ColName) && colInfo.ColControlName !== 'Hidden').forEach(colInfo => {

                _layoutConfig.Append({
                    Name: colInfo.ColName,
                    ColInfo: colInfo
                });

            });

            let list = [_layoutConfig];
            
            for (let i = 0; i < list.length; i++) {
                if (Array.isArray(list.Children)) {

                    const item = list[i];

                    if (Array.isArray(item.Children)) {

                        item.Children = item.Children.filter(child => child.ColInfo.ColControlName !== 'Hidden');

                        list = list.concat(item.Children);
                    }

                }
            }

            return _layoutConfig;

        },

        _RenderContext(h) {

            if (this.ContextMenuIsShow) {
                return (<GridContextMenu ref="ContextMenu" props={{ contextMenuList: [
                    {
                      Desc: "删除",
                      OnClick: () => {
                        this.LayoutConfig.DeleteRow(this.CurRow);
                      }
                    },
                    {
                      Desc: "前面插入一行",
                      OnClick: () => {
                        this.LayoutConfig.InsertRow(this.CurRow);
                      }
                    },
                    {
                      Desc: "后面插入一行",
                      OnClick: () => {
                        this.LayoutConfig.InsertRow(this.CurRow + 1);
                      }
                    }
                  ] }}
                nativeOnBlur={() => {
                    this.ContextMenuIsShow = false;
                    this.CurRow = -1;
                }}/>);
            }

        },

        _OnContextMenu(e, row) {

            const _position = {
                X: e.pageX,
                Y: e.pageY
            };
            e.preventDefault();
            e.stopPropagation();
            this.ContextMenuIsShow = true;
            this.CurRow = row;
            
            this.$nextTick(() => {
                this.$refs.ContextMenu.$el.focus();
                Object.assign(this.$refs.ContextMenu.$el.style, {
                    left: e.clientX + "px",
                    top: e.clientY + "px"
                });
            });

        },


        _RenderLayoutCell(h) {

            // 创建布局单元格
            const _columnNumber = this.LayoutConfig.ColumnNumber;
            const _positionInfo = this.LayoutConfig.GetPositionInfo();

            const _length = (_positionInfo.Rows + 1 - _positionInfo.Row) * (_positionInfo.Columns + 1 - _positionInfo.Column);

            const _rowList = new Array(Math.ceil(_length / _columnNumber)).fill(0).map((v, i) => {

                const _row = i + 1;

                const _cellList = new Array(_columnNumber).fill(0).map((v, i) => {

                    const _column = i % _columnNumber + 1;

                    return (<div class="cmn-grid-layout-cell" data-row={_row} data-column={_column} style={{
                        gridColumnStart: _column,
                        gridColumnEnd: _column + 1
                    }}>{_column}</div>)

                });

                const _rowNumberMarker = (<div class="cmn-grid-layout-row-marker" onContextmenu={(e) => {
                    this._OnContextMenu(e, _row);
                }}>{_row}</div>);

                return (<div class="cmn-grid-layout-row" data-row={_row} style={{
                    gridRowStart: _row,
                    gridRowEnd: _row + 1,
                }}>
                    {_rowNumberMarker}
                    {_cellList}
                </div>);

            });

            const _rows = this.LayoutMan.LayoutConfig.GetChildrenPositionInfo()?.Rows || 0;

            return (<div
                ref="GridLayout"
                class="cmn-grid-layout"
                style={{ gridRow: `1 / ${_rows}` }}
            >{_rowList}</div>);

        }
    },
    render(h) {

        if (!this.LayoutConfig) {
            return null;
        }

        let _children = [];

        _children.push(
            <div class="cmn-grid-content" ref="Grid" style={
                Object.assign({
                    userSelect: this.isCustomLayoutMode ? "none" : ''
                }, this.GridStyle)
            }>
                <ConfigView
                    props={{
                        config: {
                            isCustomLayoutMode: this.isCustomLayoutMode,
                            LayoutMan: this.LayoutMan
                        },
                        layoutConfig: this.LayoutConfig
                    }}
                    scopedSlots={this.$scopedSlots}
                />
            </div>
        );

        if (this.isCustomLayoutMode) {

            _children.push(this._RenderLayoutCell(h), this._RenderContext(h));

        }

        if (this.isCustomLayoutMode) {
            _children.push(
                <CustomLayoutMask props={{
                    layoutMan: this.LayoutMan
                }} />
            );
        }

        return (
            <div class="cmn-grid">
                { _children}
            </div>
        );
    },
    async updated() {
        if (this.isCustomLayoutMode) {
            await this.$nextTick();
            const _rowsHeight = this.LayoutConfig.GetRowsInfo().RowsHeight.join(" ");
            
            Object.assign(this.$refs.GridLayout.style, {
                gridTemplateRows: _rowsHeight
            });
        }
    }
};